import { languages } from "../constants/languages";

export const getFileTooLargeMessage = (maxSizeInMb) =>
  languages.formatString(languages.tournament.fileTooLargeWithMaxSize, maxSizeInMb);

export const validateFileSize = (file, maxSizeInMb) => {
  if ((file || {}).size > maxSizeInMb * 1024 * 1024) {
    throw Error(getFileTooLargeMessage(maxSizeInMb));
  }
};

export const getUploadErrorMessage = (error, maxSizeInMb = undefined) => {
  const errorMessage = ((error || {}).message || "").toLowerCase();
  if (
    maxSizeInMb !== undefined &&
    (error || {}).code === "storage/unauthorized"
  ) {
    return getFileTooLargeMessage(maxSizeInMb);
  }

  if (
    maxSizeInMb !== undefined &&
    errorMessage.includes(
      "firebase storage: user does not have permission to access"
    )
  ) {
    return getFileTooLargeMessage(maxSizeInMb);
  }

  if (
    maxSizeInMb !== undefined &&
    ((error || {}).code === "storage/unknown" ||
      errorMessage.includes("unknown error occurred"))
  ) {
    return getFileTooLargeMessage(maxSizeInMb);
  }

  return (error || {}).message || "";
};
